"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var styled_components_1 = __importDefault(require("styled-components"));

var button_1 = require("../Button/button");

var Container = styled_components_1.default("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: \"Nunito Sans\", sans-serif;\n  width: ", ";\n  background-color: white;\n  box-shadow: 0px 30px 30px 0px rgba(0, 0, 0, 0.1);\n  border-radius: 3px;\n  padding: 15px;\n  padding-bottom: 40px;\n"], ["\n  font-family: \"Nunito Sans\", sans-serif;\n  width: ", ";\n  background-color: white;\n  box-shadow: 0px 30px 30px 0px rgba(0, 0, 0, 0.1);\n  border-radius: 3px;\n  padding: 15px;\n  padding-bottom: 40px;\n"])), function (props) {
  return props.width;
});
var Top = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 25px;\n  span {\n    cursor: pointer;\n  }\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 25px;\n  span {\n    cursor: pointer;\n  }\n"])));
var Content = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-align: center;\n  margin-bottom: 40px;\n"], ["\n  text-align: center;\n  margin-bottom: 40px;\n"])));
var Title = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: block;\n  font-size: 22px;\n  font-weight: 600;\n  margin-bottom: 15px;\n  color: ", ";\n"], ["\n  display: block;\n  font-size: 22px;\n  font-weight: 600;\n  margin-bottom: 15px;\n  color: ", ";\n"])), function (props) {
  if (props.theme === "primary") {
    return "#2D4EF5";
  } else if (props.theme === "success") {
    return "#4CE2A7";
  } else if (props.theme === "error") {
    return "#E24C4C";
  } else if (props.theme === "alert") {
    return "#F1A153";
  } else if (props.theme === "dark") {
    return "#022047";
  }
});
var Support = styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: #666666;\n  font-size: 16px;\n"], ["\n  color: #666666;\n  font-size: 16px;\n"])));
var Buttons = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-around;\n"], ["\n  display: flex;\n  justify-content: space-around;\n"])));
var CancelBtn = styled_components_1.default(button_1.Button)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  color: #999999;\n  border-color: #dfdfdf;\n"], ["\n  color: #999999;\n  border-color: #dfdfdf;\n"])));

exports.Modal = function (_a) {
  var _b = _a.theme,
      theme = _b === void 0 ? "primary" : _b,
      _c = _a.cancelText,
      cancelText = _c === void 0 ? "Cancel" : _c,
      _d = _a.confirmText,
      confirmText = _d === void 0 ? "Next Step" : _d,
      title = _a.title,
      supportText = _a.supportText,
      className = _a.className,
      _e = _a.width,
      width = _e === void 0 ? "480px" : _e,
      onClose = _a.onClose,
      onConfirm = _a.onConfirm,
      onCancel = _a.onCancel;
  return react_1.default.createElement(Container, {
    theme: theme,
    className: className,
    width: width
  }, react_1.default.createElement(Top, null, react_1.default.createElement("span", {
    onClick: onClose
  }, react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 24 24",
    fill: "#333333"
  }, react_1.default.createElement("path", {
    d: "M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"
  })))), react_1.default.createElement(Content, null, react_1.default.createElement(Title, {
    theme: theme
  }, title), supportText ? react_1.default.createElement(Support, null, supportText) : null), react_1.default.createElement(Buttons, null, react_1.default.createElement(CancelBtn, {
    onClick: onCancel,
    content: cancelText,
    inverted: true,
    edges: "round-sharp"
  }), react_1.default.createElement(button_1.Button, {
    content: confirmText,
    primaryColor: theme,
    edges: "round-sharp",
    onClick: onConfirm
  })));
};

exports.Modal.propTypes = {
  theme: prop_types_1.default.oneOf(["primary", "success", "error", "alert", "dark"]),
  cancelText: prop_types_1.default.string,
  confirmText: prop_types_1.default.string,
  title: prop_types_1.default.string.isRequired,
  supportText: prop_types_1.default.string,
  className: prop_types_1.default.string,
  width: prop_types_1.default.string,
  onClose: prop_types_1.default.func,
  onConfirm: prop_types_1.default.func,
  onCancel: prop_types_1.default.func
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;